import PolicyDetailScreen from '../components/PolicyDetailScreen';
import SubmitterDetailScreen from '../components/SubmitterDetailScreen';
import ClaimDetailScreen from '../components/ClaimDetailScreen';
import SpecificationDetailScreen from '../components/SpecificationDetailScreen';
import DocumentationScreen from '../components/DocumentationScreen/DocumentationScreen';
import ConfirmationScreen from '../components/ConfirmationScreen';
import { translations } from './consts';

const stepsComposer = () => [
    {
        path: '/stepOne',
        screen: PolicyDetailScreen,
        step: 0,
        label: translations.stepLabel.START,
    },
    {
        path: '/stepTwo',
        screen: SubmitterDetailScreen,
        step: 1,
        label: translations.stepLabel.SUBMITTER,
    },
    {
        path: '/stepThree',
        screen: ClaimDetailScreen,
        step: 2,
        label: translations.stepLabel.DETAILS,
    },
    {
        screen: SpecificationDetailScreen,
        path: '/stepFour',
        step: 3,
        label: translations.stepLabel.SPECIFICATION,
    },
    {
        screen: DocumentationScreen,
        path: '/stepFive',
        step: 4,
        label: translations.stepLabel.DOCUMENTATION,
    },
    {
        path: '/stepSix',
        screen: ConfirmationScreen,
        step: 5,
        label: translations.stepLabel.CONFIRMATION,
    },
];

export default stepsComposer;
